import { render } from "./Signin.vue?vue&type=template&id=690628b8"
import script from "./Signin.vue?vue&type=script&lang=js"
export * from "./Signin.vue?vue&type=script&lang=js"
script.render = render

export default script